// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_t-rrD","logo-container":"logo-container_7XbYQ"};